module.exports = __webpack_public_path__ + "static/media/29DUNON10.40cc0a72.jpg";